import React, { createContext, useState, useContext, useCallback } from "react";

const SearchContext = createContext();

export const useSearch = () => {
  const context = useContext(SearchContext);
  if (!context) {
    throw new Error("useSearch must be used within a SearchProvider");
  }
  return context;
};

export const SearchProvider = ({ children }) => {
  const [searchState, setSearchState] = useState(() => {
    const saved = localStorage.getItem("searchState");
    try {
      return saved ? JSON.parse(saved) : { query: "", results: [] };
    } catch {
      return { query: "", results: [] };
    }
  });

  const updateSearch = useCallback((newState) => {
    setSearchState((prev) => {
      const updated = { ...prev, ...newState };
      localStorage.setItem("searchState", JSON.stringify(updated));
      return updated;
    });
  }, []);

  const clearSearch = useCallback(() => {
    setSearchState({ query: "", results: [] });
    localStorage.removeItem("searchState");
  }, []);

  return (
    <SearchContext.Provider value={{ searchState, updateSearch, clearSearch }}>
      {children}
    </SearchContext.Provider>
  );
};